// =========================
// GUIDE COMPONENT
// =========================
// External Libraries
import { LitElement, html } from 'lit';
import introJs from 'intro.js';
import 'intro.js/introjs.css';

// App Modules
import Auth from '../Auth';
import App from '../App';

// This is the PopinGuide class that handles the user guide
// It includes methods for starting the guide and marking it as complete
class PopinGuide extends LitElement {
  static properties = {
    user: { type: Object },
  };

  constructor() {
    super();
    this.user = Auth.currentUser;
  }

  // LIFECYCLE METHODS

  async _start() {
    await this._waitForRender();

    // Check if the user has already seen the guide
    introJs()
      .setOptions({
        steps: [
          {
            element: document.querySelector('popin-poster'),
            intro: 'Create a post and share what’s on your mind!',
          },
          {
            element: document.querySelector('#feed-posts'),
            intro: 'Here you can view posts from other users.',
          },
          {
            element: document.querySelector('popin-side-nav'),
            intro: 'Navigate to different areas using the sidebar.',
          },
          {
            element: document.querySelector('popin-top-bar'),
            intro: 'Access your profile and settings from here.',
          },
        ],
        showProgress: true,
        exitOnOverlayClick: false,
        disableInteraction: true,
        showBullets: false,
        nextLabel: 'Next',
        prevLabel: 'Back',
        doneLabel: 'Finish',
      })
      .oncomplete(() => this.markGuideComplete())
      .onexit(() => this.markGuideComplete())
      .start();
  }

  // This method waits for the DOM to be rendered before starting the guide
  async _waitForRender() {
    return new Promise((resolve) => {
      setTimeout(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(resolve);
        });
      }, 50);
    });
  }

  // This method is called when the user clicks the "Start Guide" button
  startGuide() {
    this._start();
  }

  // This method is called when the user completes the guide
  // It updates the user's status in the database
  async markGuideComplete() {
    try {
      const res = await fetch(`${App.apiBase}/user/${this.user.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ hasSeenGuide: true }),
      });
      if (!res.ok) throw new Error('Failed to update guide status');

      const updatedUser = await res.json();
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));
    } catch (err) {
      console.error('Error marking guide as seen:', err);
    }
  }

  render() {
    return html``;
  }
}

customElements.define('popin-guide', PopinGuide);
